import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Consultation & Energy.",
    copy:
      "Every appointment starts with a conversation. Your hair, your face shape, how you carry yourself — we listen before we cut. The chair is a space to relax, be seen, and be understood.",
  },
  {
    num: "02",
    title: "Sculpting & Lineage.",
    copy:
      "Twenty-five years of technique, taught and refined — from Dudley's advanced clipper work to modern Atlanta editorial styling. Every fade, shape-up, and finish is executed with a lineage of craft behind it.",
  },
  {
    num: "03",
    title: "The Transformation.",
    copy:
      "You leave sharper than you walked in — not just cleaner. This is what more than a haircut looks like: precision, positive energy, and a look that carries confidence into your whole week.",
  },
];

export default function Manifesto() {
  return (
    <section
      id="studio"
      className="relative bg-black text-white py-24 md:py-40 overflow-hidden"
      data-testid="manifesto-section"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 gap-6 md:gap-10 mb-16 md:mb-24">
          <div className="col-span-12 md:col-span-3">
            <div className="eyebrow mb-6">§ The Ritual</div>
          </div>
          <div className="col-span-12 md:col-span-9">
            <motion.h2
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 1, ease: [0.7, 0, 0.2, 1] }}
              className="font-serif text-4xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.95] tracking-tight"
            >
              Come in for the cut.
              <br />
              <span className="italic text-zinc-400">
                Stay for the experience.
              </span>
            </motion.h2>
          </div>
        </div>

        <div className="space-y-16 md:space-y-24">
          {CHAPTERS.map((c, i) => (
            <motion.article
              key={c.num}
              initial={{ opacity: 0, y: 60 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.9, delay: i * 0.08, ease: [0.7, 0, 0.2, 1] }}
              className="grid grid-cols-12 gap-6 md:gap-10 items-start border-t border-white/10 pt-10 md:pt-14"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="col-span-12 md:col-span-3">
                <div className="font-serif text-6xl md:text-8xl text-white/25 leading-none">
                  {c.num}
                </div>
              </div>
              <div className="col-span-12 md:col-span-4">
                <h3 className="font-serif text-2xl md:text-4xl leading-tight tracking-tight">
                  {c.title}
                </h3>
              </div>
              <div className="col-span-12 md:col-span-5">
                <p className="text-zinc-400 text-base md:text-lg leading-relaxed max-w-md">
                  {c.copy}
                </p>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
